<template>
  <div class="checkFile" v-if="data">
    <div class="tit">
      <span class="t1">{{data.course.course_name}}题库</span>
    </div>

    <div class="show_con">
      <div class="list">
        <div class="iname" v-for="item in data.attachment_file_list" :key="item.name" @click="onitem(item)">{{item.name}}</div>
      </div>
      <div class="con">
        <iframe :src="iframe_src"></iframe>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: 'checkFile',
  data:function () {
    return {
      data:null,
      iframe_src:'',
    }
  },
  created(){
    console.log("checkFile created", this.$route)
    this.fetch()
  },
  methods:{
    async fetch(){

      let res = await this.$fly.get('/course/courseAttachmentFileList',{course_id:this.$route.params.course_id});
      this.data = res;
      console.log("this.data:", this.data);

      this.iframe_src = this.data.attachment_file_list[0].url;
      
    },
    onitem(item){
      this.iframe_src = item.url;
    }
    
  }
}
</script>

<style lang='scss'>
  
  .list::-webkit-scrollbar {
    /*滚动条整体样式*/
    width : 10px;  /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }
  .list::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    background   : #00B3A4;
  }
  .list::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    background   : #ededed;
  }

.checkFile{
  width: 1024px;
  margin: 0 auto;

  .tit{
    background-color:#fff;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.50);
    padding:10px 14px;
    border-radius: 5px;
    display:flex;
    align-items:baseline;
    margin: 20px 0;

    .t1{
      font-size: 20px;
      color: #00B3A4;
    }

  }

  .show_con{
    display:flex;
    justify-content:space-between;
    margin-bottom: 20px;

    .list{
      width: 260px;
      max-height: 630px;
      overflow: hidden;
      overflow-y: auto;
      background-color: #fff;
      color: #00B3A4;

      .iname:hover{
        background-color: #e6f7f6;
        color: #33c2b6;
      }
      .iname{
        cursor: pointer;
        padding: 10px;
        border-bottom: 1px solid;
      }
    }

    .con{
      width: 740px;
      height: 630px;

      iframe{
        width: 100%;
        height: 100%;
        border: none;
      }

    }

  }
  
}

</style>